import { setSession } from './utils';
import { AuthUserType } from '../../types';

export const setSessionFromResponse = (
  response: any,
  changeLanguage: (lang: string) => void,
  callback: (user: AuthUserType) => void
): void => {
  const { user } = response.data;
  const { 'access-token': accessToken, client, uid, expiry, 'token-type': tokenType } = response.headers;

  console.log(response.headers);
  console.log(accessToken, client, uid, expiry, tokenType);

  setSession(accessToken, client, expiry, uid, tokenType);

  if (user.language_setting) {
    changeLanguage(user.language_setting);
  }

  callback(user);
};
